import { Component, OnInit, Input, EventEmitter, Output} from "@angular/core";
import { Router } from "@angular/router";
import { Opcion } from 'projects/modulo-solicitudes/src/solicitudes/interfaces/solicitudes';

@Component({
	selector: "app-opciones-tabla",
	templateUrl: "./opciones-tabla.component.html",
	styleUrls: ["./opciones-tabla.component.css"],
})
export class OpcionesTablaComponent implements OnInit {
	constructor(private route: Router) {}

	@Input() listadoAcciones: Array<Opcion>;
	@Input() ID: number;
	@Input() EstatusSolicitud: any;
	@Input() autorizar: boolean = false;
	@Input() enviarEmitVisible: boolean = false;
	@Output() accionEnviadaEmit: EventEmitter<any> = new EventEmitter<any>();

	ngOnInit(): void {
		console.log(this.autorizar);
	}

	acciones(accion) {
		let elementoEncontrado = this.listadoAcciones.find(
			(elemento) => elemento.Accion === accion
		);

		if (elementoEncontrado) {
			if(this.enviarEmitVisible){
				this.accionEnviadaEmit.emit(elementoEncontrado);
			}else{

				this.route.navigate([elementoEncontrado.Url + this.ID]);
			}
		}
	}

	mostrarOpcion(opcion){
		console.log(opcion);
		if(opcion.EstatusVisibles.length > 0){
			opcion.EstatusVisibles.forEach( elemento => {
				if(elemento == this.EstatusSolicitud){
					return true;
				}
			});
		}
	}

	visibleOpcion(opcion){
		let estatusEncontrado: boolean;

		if(this.EstatusSolicitud !== null && this.EstatusSolicitud !== undefined ){
			estatusEncontrado = opcion.EstatusVisibles.find(item => item === this.EstatusSolicitud);
		}else{
			estatusEncontrado = true;
		}

		return estatusEncontrado && opcion.Visible ? true : false;
	}
}
